import InvitePeopleDrawer from './ui';

export { projectTypeToSubProduct } from './ui/content/utils';

export default InvitePeopleDrawer;
